(function (window, document, $) {
    function getUniqueArrayValues(arr) {
        return Array.from(new Set(arr));
    }

    function getNotUniqueArrayValues(arr) {
        var newArr = [];
        var arrQty = arr.length - 1;
        for (var i = 0; i < arrQty; i++) {
            if (arr[i + 1] == arr[i]) {
                newArr.push(arr[i]);
            }
        }
        return newArr;
    }

    $(window).on('load', function() {
        var countryCode = document.querySelector('html').lang.split('-')[1];
        var pageName = $('#pageName').val() || $("#pageLabel").val() || $('#pgTemplate').val() || $('#pageType').val() || $('input[name="pageLabel"]').val();
        var wcagCountryCodes = ['US', 'CA'];
        var exclusionPages = ['Delivery', 'ShopCart', 'Payment', 'MyDetails', 'Login and Register', 'DeliveryPage', 'paymentRedesign', 'CheckoutLogon'];
        var isWcagCountry = wcagCountryCodes.includes(countryCode);
        var isExclusionPage = pageName ? exclusionPages.includes(pageName) : true;

        if (isWcagCountry && !isExclusionPage) {
            var hiddenFieldsIds = [].slice.call(document.querySelectorAll('[type="hidden"][id]:not([id=""])')).map(function (item) {return item.id}).slice().sort();
            var duplicatedIds = getNotUniqueArrayValues(hiddenFieldsIds);
            var uniqueDuplicatedIds = getUniqueArrayValues(duplicatedIds);
            uniqueDuplicatedIds.forEach(function(idString) {return $('[type="hidden"]#' + idString + ':gt(0)').remove()} );
        }
    });

})(window, document, jQuery);
